import { render, staticRenderFns } from "./origanization.vue?vue&type=template&id=47865256&"
import script from "./origanization.vue?vue&type=script&lang=ts&"
export * from "./origanization.vue?vue&type=script&lang=ts&"
import style0 from "./origanization.vue?vue&type=style&index=0&id=47865256&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports